import React from "react";
import PropTypes from "prop-types";

Contact.propTypes = {};

function Contact(props) {
  return <div>Contact</div>;
}

export default Contact;
